import { render, staticRenderFns } from "./VaButtonToggle.demo.vue?vue&type=template&id=19c16a86&"
import script from "./VaButtonToggle.demo.vue?vue&type=script&lang=js&"
export * from "./VaButtonToggle.demo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports